import { createContext } from "react";
import type { ActiveSession } from "@autorepair/contracts";

export interface AuthContextValue {
  session: ActiveSession | null;
  /** True only while the very first session check is in flight — after
   * that, `session` being null just means "logged out". */
  loading: boolean;
  setSession: (session: ActiveSession | null) => void;
  logout: () => Promise<void>;
  /** Revokes every session for this user (all devices, including this
   * one) — a separate, more drastic action than logout(). */
  logoutAllDevices: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
